import WidgetPage from "src/components/page/widget"
export default WidgetPage
